module.exports = __webpack_public_path__ + "img/graph.1e108d4a.png";